<template>
	<div>
		<div style="background-color: #F6F8FE;height: 50px;">
			 <el-button type="text" style="color: #000000;" icon="arrow-left" @click="backBtn">
				 返回
			 </el-button>
		</div>
		
		<div class="container">
			<div class="addEnterprises">
			  <el-form
			    :model="ruleForm"
			    :rules="rules1"
			    ref="ruleForm"
			    label-width="150px"
			    class="demo-ruleForm">
					
					<el-form-item prop="FileNo" label="数据类型">
					  <el-select v-model="dataTypeValue" placeholder="请选择数据类型">
							<el-option
								v-for="item in dataOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					
			    <el-form-item prop="FileNo" label="患者编号">
			      <el-input
			        placeholder="请输入患者编号(最长16位字符)"
			        v-model="ruleForm.FileNo" :maxlength="16">
						</el-input>
			    </el-form-item>
					
			    <el-form-item prop="PatientName" label="患者姓名" >
			      <el-input
			        v-model="ruleForm.PatientName"
			        placeholder="请输入患者姓名(最长16位字符)"
			      :maxlength="16"></el-input>
			    </el-form-item>
					
					<el-form-item prop="OrderTime" label="订单日期" >
		
						<el-date-picker
						      v-model="ruleForm.OrderTime"
						      type="date"
									:editable="false"
						      placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
							
					<el-form-item prop="Hospital" label="所属医院" >
					  <el-input
					    v-model="ruleForm.Hospital"
					    placeholder="请输入所属医院(最长16位字符)"
							:maxlength="16"></el-input>
					</el-form-item>
					
				
					<!-- 常用值  0.625    1    1.25 -->
					<el-form-item prop="TimeInterval"   label="CT间隔" >
					  <el-input :disabled="timeIntervalDisabled"
					    v-model="ruleForm.TimeInterval"
					    placeholder="请输入CT间隔 (范围值在0.125-5,单位为mm)"
							:maxlength="6"></el-input>
					</el-form-item>
					
					
			    <div class="submit marleft">
			      <el-button
			        type="primary"
			        style="width:100px;height: 40px;font-size: 14px;"
			        @click="alterFile"
							class="upLoadBtn">
							确认修改
						</el-button>
			    </div>
			  </el-form>
			
				<!-- 上传模型按钮 -->
				<div style="width: 500px; height: 300px; 
					margin-left: 500px; margin-top: -450px;">
						
					<!-- action="http://192.168.200.124:8002/ZhenYuan/UploadFile/" -->
					<!-- action="http://112.125.27.239:8002/ZhenYuan/UploadFile/" -->
					<!-- action="http://47.105.158.91:8002/ZhenYuan/UploadFile/" -->
					
					<el-upload 
						class="upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload"
						:on-preview="handlePreview"
						:on-remove="handleRemove"
						:on-success="handleSuccess"
						:before-remove="beforeRemove"
						multiple
					  :limit="1"
						:on-exceed="handleExceed"
						:file-list="fileList">
						<el-button :disabled="disabled"  size="middle" style="color: #1F6AAB;">选择文件</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle}}</div>
					</el-upload>
					
					
					<!-- 上传CT文件1按钮 -->
					<el-upload style="margin-top: 20px;"
						class="ct1upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload_CT1"
						:on-preview="handlePreview_CT1"
						:on-remove="handleRemove_CT1"
						:on-success="handleSuccess_CT1"
						:before-remove="beforeRemove_CT1"
						multiple
					  :limit="1"
						:on-exceed="handleExceed_CT1"
						:file-list="fileList_CT1">
						<el-button :disabled="disabled_CT1"  size="middle" style="color: #1F6AAB;">CT文件1</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle_CT1}}</div>
					</el-upload>
					<el-button type="text" :style="{ display: delCT1Btn }"  @click.native="deleteCT1()">删除该文件</el-button>
					
					
					<!-- 上传CT文件2按钮 -->
					<el-upload style="margin-top: 20px;"
						class="ct2upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload_CT2"
						:on-preview="handlePreview_CT2"
						:on-remove="handleRemove_CT2"
						:on-success="handleSuccess_CT2"
						:before-remove="beforeRemove_CT2"
						multiple
					  :limit="1"
						:on-exceed="handleExceed_CT2"
						:file-list="fileList_CT2">
						<el-button :disabled="disabled_CT2"  size="middle" style="color: #1F6AAB;">CT文件2</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle_CT2}}</div>
					</el-upload>
					<el-button type="text" :style="{ display: delCT2Btn }" @click.native="deleteCT2()">删除该文件</el-button>
					
					<!-- 上传CT文件3按钮 -->
					<el-upload style="margin-top: 20px;"
						class="ct3upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload_CT3"
						:on-preview="handlePreview_CT3"
						:on-remove="handleRemove_CT3"
						:on-success="handleSuccess_CT3"
						:before-remove="beforeRemove_CT3"
						multiple
					  :limit="1"
						:on-exceed="handleExceed_CT3"
						:file-list="fileList_CT3">
						<el-button :disabled="disabled_CT3"  size="middle" style="color: #1F6AAB;">CT文件3</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle_CT3}}</div>
					</el-upload>
					<el-button type="text" :style="{ display: delCT3Btn }" @click.native="deleteCT3()">删除该文件</el-button>
					
					<!-- 上传DCM文件1按钮 -->
					<el-upload style="margin-top: 20px;"
						class="ct4upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload_DCM"
						:on-preview="handlePreview_DCM"
						:on-remove="handleRemove_DCM"
						:on-success="handleSuccess_DCM"
						:before-remove="beforeRemove_DCM"
						multiple
					  :limit="1"
						:on-exceed="handleExceed_DCM"
						:file-list="fileList_DCM">
						<el-button :disabled="disabled_DCM"  size="middle" style="color: #1F6AAB;">Dicom文件</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle_DCM}}</div>
					</el-upload>
					<el-button type="text" :style="{ display: delCTDcmBtn }" @click.native="deleteDCM()">删除该文件</el-button>
				</div>
				
			
			</div>
			
			
		  </div>
		</div>
		
	</div>

</template>

<script>
import { AlterFile } from "@/api/api";
export default {
  data() {
		const validateOrderTime = (rule, value, callback) => {
			// var reg = /\d{4}-\d{2}-\d{2}/;
			// if (!reg.test(value)) {
			//   callback(new Error('请选择时间'))
			// } 
			if (value.length < 1) {
			  callback(new Error('请选择时间'))
			} 
			else{
		    callback()
		  }
		}
		const validateHospital = (rule, value, callback) => {
		  if (value.length < 1) {
		    callback(new Error('请输入医院名称'))
		  }  else{
		    callback()
		  }
		}
		
		const validateTimeInterval = (rule, value, callback) => {
				if(!isNaN(value)){　
				  if (parseFloat(value) < 0.125) {
				    callback(new Error('请输入正确的数据值,范围值在0.125-5'))
				  } else if (parseFloat(value) > 5) {
				    callback(new Error('请输入正确的数据值,范围值在0.125-5'))
				  } else { 
		　　　　callback()
		　　		}
			　} else { 
		　　　callback(new Error('请输入正确的数据值,范围值在0.125-5'))
		　　}
			}

    const validateName = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('请输入姓名'))
      } else if (value.length > 32) {
        callback(new Error('姓名字符超限'))
      } else{
        callback()
      }
    }
    const validateFileNo = (rule, value, callback) => {
      // var reg = /^[0-9]/;
      // if (!reg.test(value))
			var reg = /^[0-9a-zA-Z]{1,}$/;
			if (!reg.test(value)) {
			  callback(new Error('请输入字母或者数字'))
			} 
			else if (value.length < 6) {
        callback(new Error('请输入至少6位患者编号'))
      } else if (value.length > 32) {
        callback(new Error('编号字符超限'))
      } 
			else{
        callback()
      }
    }
   
    return {
			// 数据类型     (0, '肺'), (1, '泌尿'), (2, '神外'), (3, '肝胆'), (4, '心脏')
			dataOptions: [
				{
					value: 0,
					label: '肺'
				},
				{
					value: 1,
					label: '泌尿'
				},
				{
					value: 2,
					label: '神外'
				},
				{
					value: 3,
					label: '肝胆'
				},
				{
					value: 4,
					label: '心脏'
				},
				// 新加
				{
					value: 5,
					label: '胰腺'
				},
				{
					value: 6,
					label: '甲状腺'
				},
				{
					value: 7,
					label: '耳鼻喉'
				},
				{
					value: 8,
					label: '食管'
				},
				{
					value: 9,
					label: '纵膈'
				},
								{
					value: 10,
					label: '胸外'
				},
				{
					value: 11,
					label: '普外'
				},
				{
					value: 12,
					label: '骨科'
				},
				{
					value: 13,
					label: '乳腺'
				},
				{
					value: 14,
					label: '妇科'
				},
				{
					value: 15,
					label: '胃肠'
				},
				{
					value: 16,
					label: '血管'
				},
								{
					value: 17,
					label: '腹腔'
				},
				{
					value: 18,
					label: '盆腔'
				}

			],
			dataTypeValue: "",
			tipTitle: '请选择模型文件(*.zip)',
			tipTitle_CT1: '请选择第一个CT文件(*.zip)',
			tipTitle_CT2: '请选择第二个CT文件(*.zip)',
			tipTitle_CT3: '请选择第三个CT文件(*.zip)',
			tipTitle_DCM: '请选择Dicom文件(*.zip)',
			value1: '',
			delCT1Btn: "none",
			delCT2Btn: "none",
			delCT3Btn: "none",
			delCTDcmBtn: "none",
			disabled: false,
			disabled_CT1: false,
			disabled_CT2: true,
			disabled_CT3: true,
			disabled_DCM: false,
			timeIntervalDisabled: true,
			fileList: [],
			fileList_CT1: [],
			fileList_CT2: [],
			fileList_CT3: [],
			fileList_DCM: [],
			CTFileUrlNum: 0,
      rules1: {
        FileNo: [{ required: true, trigger: 'blur', validator: validateFileNo }],
        PatientName: [{ required: true, trigger: 'blur', validator: validateName }],
				OrderTime: [{ required: true, trigger: 'blur', validator: validateOrderTime }],
				Hospital: [{ required: true, trigger: 'blur', validator: validateHospital }],
				TimeInterval: [{ required: true, trigger: 'blur', validator: validateTimeInterval }]
				
      },
      ruleForm: {
        PatientName: "",
        OrderTime: "",
        Hospital: "",
				FileNo: "",
				FileUrl: "",
				CTFileUrl1: "",
				CTFileUrl2: "",
				CTFileUrl3: "",
				CTFileUrlDcm: "",
				TimeInterval: ""
      }
    };
  },
  created() {
		console.log("created")
		console.log(this.$route.query)
		
		// Hospital: "武汉金银潭医院"
		// DateRecord: "2020-02-09"
		// PersonName: "测试数据类型"
		// ModeType: "Model1"
		// FileCode: "ZY21894812"
		// Code: "KKK111"
		// FileCodeStatus: "已上传"
		// DownUrl: "http://47.105.158.91:8001/tools/2020021116480385案例演示2.zip"
		// ProtocolId: 2002
		// ErrorDes: ""
		// DataType: "肝"
		// ErrorCode: 0
		var fileData =  this.$route.query
		
		// (0, '肺'), (1, '泌尿'), (2, '神外'), (3, '肝胆'), (4, '心脏')
	
		
		this.dataTypeValue = this.dataOptions[parseInt(fileData.DataType)].label

		this.ruleForm.TimeInterval = fileData.TimeInterval
		
		this.ruleForm.PatientName = fileData.PersonName
		this.ruleForm.FileNo = fileData.Code
		this.ruleForm.OrderTime = fileData.DateRecord
		this.ruleForm.Hospital = fileData.Hospital
		
		// 模型文件截取
		this.ruleForm.FileUrl = fileData.DownUrl
		this.tipTitle = fileData.DownUrl.split("tools")[1].substring(17)
		// this.disabled = true
		
	
		if (fileData.CTFileUrl1.indexOf("http:") != -1 ) {
			this.ruleForm.CTFileUrl1 = fileData.CTFileUrl1
			this.tipTitle_CT1 = fileData.CTFileUrl1.split("tools")[1].substring(17)
			this.disabled_CT2 = false
			this.timeIntervalDisabled = false
			this.delCT1Btn = ""
		} 
		if (fileData.CTFileUrl2.indexOf("http:") != -1 ) {
			this.ruleForm.CTFileUrl2 = fileData.CTFileUrl2
			this.tipTitle_CT2 = fileData.CTFileUrl2.split("tools")[1].substring(17)
			this.disabled_CT3 = false
			this.delCT2Btn = ""
		}
		if (fileData.CTFileUrl3.indexOf("http:") != -1 ) {
			this.ruleForm.CTFileUrl3 = fileData.CTFileUrl3
			this.tipTitle_CT3 = fileData.CTFileUrl3.split("tools")[1].substring(17)
			this.delCT3Btn = ""
		}
		if (fileData.CTFileUrlDcm.indexOf("http:") != -1 ) {
			this.ruleForm.CTFileUrlDcm = fileData.CTFileUrlDcm
			this.tipTitle_DCM = fileData.CTFileUrlDcm.split("tools")[1].substring(17)
			this.delCTDcmBtn = ""
		}
		
  },
	activated(){},
  methods: {
		// 删除第一个CT文件，只是将
		deleteCT1() {
			this.ruleForm.CTFileUrl1 = ""
			this.delCT1Btn = "none"
			this.tipTitle_CT1 = "请选择第一个CT文件(*.zip)"
		},
		
		deleteCT2() {
			this.delCT2Btn = "none"
			this.ruleForm.CTFileUrl2 = ""
			
			this.tipTitle_CT2 = "请选择第二个CT文件(*.zip)"
		},
		
		deleteCT3() {
			this.delCT3Btn = "none"
			this.ruleForm.CTFileUrl3 = ""
			this.tipTitle_CT3 = "请选择第三个CT文件(*.zip)"
		},
		
		deleteDCM() {
			this.delCTDcmBtn = "none"
			this.ruleForm.CTFileUrlDcm = ""
			this.tipTitle_DCM = "请选择Dicom文件(*.zip)"
		},
		// 后退
		backBtn() {
			this.$router.push({ path: "/FileList"});
		},
		onBeforeUpload(file) {
			this.disabled = true
			console.log('onBeforeUpload');
			console.log(file);
		},
		onBeforeUpload_CT1(file) {
			this.disabled_CT1 = true
		},
		onBeforeUpload_CT2(file) {
			this.disabled_CT2 = true
			
			
		},
		onBeforeUpload_CT3(file) {
			this.disabled_CT3 = true
		},
		onBeforeUpload_DCM(file) {
			this.disabled_DCM = true
		},
		handlePreview(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handlePreview_CT1(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handlePreview_CT2(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handlePreview_CT3(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handlePreview_DCM(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handleExceed(files, fileList) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleExceed_CT1(files, fileList_CT1) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleExceed_CT2(files, fileList_CT2) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleExceed_CT3(files, fileList_CT3) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleExceed_DCM(files, fileList_DCM) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleSuccess(response, file, fileList) {
			console.log('handleSuccess');
			console.log(response);
			console.log(response.FileUrl);
			this.ruleForm.FileUrl = response.FileUrl
			this.tipTitle = file.name
			this.disabled = true
			
		},
		
		handleSuccess_CT1(response, file, fileList_CT1) {
			this.ruleForm.CTFileUrl1 = response.FileUrl
			this.tipTitle_CT1 = file.name
			this.disabled_CT1 = true
			this.disabled_CT2 = false
			this.timeIntervalDisabled = false
			
		},
		
		handleSuccess_CT2(response, file, fileList_CT2) {
			this.ruleForm.CTFileUrl2 = response.FileUrl
			this.tipTitle_CT2 = file.name
			this.disabled_CT2 = true
			this.disabled_CT3 = false
		},
		
		handleSuccess_CT3(response, file, fileList_CT3) {
			this.ruleForm.CTFileUrl3 = response.FileUrl
			this.tipTitle_CT3 = file.name
			this.disabled_CT3 = true
		},

		handleSuccess_DCM(response, file, fileList_DCM) {
			this.ruleForm.CTFileUrlDcm = response.FileUrl
			this.tipTitle_DCM = file.name
			this.disabled_DCM = true
		},
		
		handleRemove(file, fileList) {
			this.ruleForm.FileUrl = ''
			this.tipTitle = '请选择模型文件(*.zip)'
			this.disabled = false
		},
		
		handleRemove_CT1(file, fileList_CT1) {
			this.ruleForm.CTFileUrl1 = ''
			this.tipTitle_CT1 = '请选择第一个CT文件(*.zip)'
			this.disabled_CT1 = false
		},
		
		handleRemove_CT2(file, fileList_CT2) {
			this.ruleForm.CTFileUrl2 = ''
			this.tipTitle_CT2 = '请选择第二个CT文件(*.zip)'
			this.disabled_CT2 = false
		},
		
		handleRemove_CT3(file, fileList_CT3) {
			this.ruleForm.CTFileUrl3 = ''
			this.tipTitle_CT3 = '请选择第三个CT文件(*.zip)'
			this.disabled_CT3 = false
		},
		
		handleRemove_DCM(file, fileList_DCM) {
			this.ruleForm.CTFileUrlDcm = ''
			this.tipTitle_DCM = '请选择Dicom文件(*.zip)'
			this.disabled_DCM = false
		},
		
		beforeRemove(file, fileList) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		
		beforeRemove_CT1(file, fileList_CT1) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		beforeRemove_CT2(file, fileList_CT2) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		beforeRemove_CT3(file, fileList_CT3) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		beforeRemove_DCM(file, fileList_DCM) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		
	
		//修改文件
    alterFile() {
			// 数据类型    (0, '肺'), (1, '泌尿'), (2, '神外'), (3, '肝胆'), (4, '心脏')
			
			
			
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
				  if(this.ruleForm.FileUrl == ''){
						this.$message({
							title: "error",
							message: "请选择模型文件(*.zip)",
							type: "error"
						});
					} else{
						let data = {};
						// console.log(this.dataTypeValue)
						data.FileCode = this.$route.query.FileCode
						data.PatientName = this.ruleForm.PatientName;
						// 统一订单日期为后端易解析的字符串格式
						let orderTime = this.ruleForm.OrderTime;
						if (orderTime instanceof Date) {
							const y = orderTime.getFullYear();
							const m = ('0' + (orderTime.getMonth() + 1)).slice(-2);
							const d = ('0' + orderTime.getDate()).slice(-2);
							orderTime = `${y}-${m}-${d} 00:00:00`;
						} else if (typeof orderTime === 'string' && orderTime.length === 10) {
							orderTime = `${orderTime} 00:00:00`;
						}
						data.OrderTime = orderTime;
						data.Hospital = this.ruleForm.Hospital;
						data.FileNo =  this.ruleForm.FileNo;
						data.FileUrl = this.ruleForm.FileUrl;
						data.CTFileUrl1 = this.ruleForm.CTFileUrl1;
						data.CTFileUrl2 = this.ruleForm.CTFileUrl2;
						data.CTFileUrl3 = this.ruleForm.CTFileUrl3;
						data.CTFileUrlDcm = this.ruleForm.CTFileUrlDcm;
						data.TimeInterval = this.ruleForm.TimeInterval;
						console.log("this.dataTypeValue = " + this.dataTypeValue)
						if(this.dataTypeValue == "肺"){
							
							data.DataType = 0
						} 
						else if (this.dataTypeValue == "泌尿") {
							
							data.DataType = 1
						}
						else if (this.dataTypeValue == "神外") {
						
							data.DataType = 2
						}
						else if (this.dataTypeValue == "肝胆") {
							
							data.DataType = 3
						}
						else if (this.dataTypeValue == "心脏") {
							
							data.DataType = 4
						}
						else if (this.dataTypeValue == "胰腺") {
							
							data.DataType = 5
						}
						else if (this.dataTypeValue == "甲状腺") {
							
							data.DataType = 6
						}
						else if (this.dataTypeValue == "耳鼻喉") {
							
							data.DataType = 7
						}
						else if (this.dataTypeValue == "食管") {
							
							data.DataType = 8
						}
						else if (this.dataTypeValue == "纵膈") {
							
							data.DataType = 9
						}
						else if (this.dataTypeValue == "胸外") {
							
							data.DataType = 10
						}
						else if (this.dataTypeValue == "普外") {
							
							data.DataType = 11
						}
						else if (this.dataTypeValue == "骨科") {
							
							data.DataType = 12
						}
						else if (this.dataTypeValue == "乳腺") {
							
							data.DataType = 13
						}
						else if (this.dataTypeValue == "妇科") {
							
							data.DataType = 14
						}
						else if (this.dataTypeValue == "胃肠") {
							
							data.DataType = 15
						} 
						else if (this.dataTypeValue == "血管") {
							
							data.DataType = 16
						}
						else if (this.dataTypeValue == "腹腔") {
							
							data.DataType = 17
						}
						else if (this.dataTypeValue == "盆腔") {
							
							data.DataType = 18
						}
						else {
							data.DataType = parseInt(this.dataTypeValue);
						}
						
						
						
						
						var ctFileList=[data.CTFileUrl1, data.CTFileUrl2, data.CTFileUrl3, data.CTFileUrlDcm];
						
						console.log("ctFileList = " + ctFileList)
						
						var alterCTFileUrlNum = 0
						for (let ctfile in ctFileList) {
							console.log(ctfile)
							console.log("ctfile = " + ctFileList[ctfile])
							// 如果字符串不包含http:
							if (ctFileList[ctfile].indexOf("http:") != -1 ) {
								alterCTFileUrlNum++;
								console.log("alterCTFileUrlNum++ = " + alterCTFileUrlNum)
							} 
						}
					
						data.CTFileUrlNum = alterCTFileUrlNum;
						console.log(data)
						AlterFile(data).then(res => {
						  console.log("AlterFile = " + res);
							
							if (JSON.stringify(res) == '{}') {
									// return true;
									this.$message({
										title: "error",
										message: "修改文件失败",
										type: "error"
									});
							} else {
								this.$message({
									title: "success",
									message: "修改文件成功",
									type: "success"
								});
									
								this.$router.push({ path: "/fileList" });
							}
							// 将CTFileUrlNum重置为0
							this.CTFileUrlNum = 0;
							
						});
					}
          
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
  }
};
</script>

<style lang="scss" scoped>
.marleft {
  margin-left: 70px;
}
.upLoadBtn{
		width:168px;
		height:58px;
		background:rgba(34,107,170,1);
		border-radius:4px;
		border:1px solid rgba(83,113,255,1);
		
		font-size:16px;
		font-family:PingFangSC-Regular,PingFangSC;
		font-weight:400;
		color:rgba(255,255,255,1);
		line-height:8px;
	}
.addForm {
  height: 1000px;
}
.openaddbtn {
  height: 58px;
  text-align: center;
  background: rgba(248, 248, 248, 1);
  line-height: 58px;
}
.container {
	margin-top: 50px;
  width: 1200px;
	height: 500px;
  // padding-bottom: 30px;
	background: #FFFFFF;
}
.el-form-item {
	margin-top: 20px;
	margin-left: -75px;
  width: 450px;
}
.addEnterprises {
  margin-top: 30px;
	margin-left: 10px;
  // margin-bottom: 130px;
}
.submitBtn {
  margin-top: 50px;
}
.submit {
  margin-top: 83px;
}
.el-form-item .label {
	font-size: 24px;
	font-family:PingFangSC-Semibold,PingFangSC;
}


.el-date-editor--date{width: 330px;}
.el-upload__tip{display: inline-block;margin-left: 20px;}
</style>



// WEBPACK FOOTER //
// AlterFile.vue?617e9e5d